// extracted by mini-css-extract-plugin
export default {"wrapper":"GameOptions_wrapper__Nbpkc","middleContent":"GameOptions_middleContent__UxeiA","bottomContent":"GameOptions_bottomContent__yWmJv","hide":"GameOptions_hide__hjE2g"};